import {
  GET_LINKS,
  GET_LINKS_ERROR,
  GET_LINKS_SUCCESS,

  GET_LINK,
  GET_LINK_ERROR,
  GET_LINK_SUCCESS,

  SAVE_LINK,
  SAVE_LINK_ERROR,
  SAVE_LINK_SUCCESS,

  DELETE_LINK,
  DELETE_LINK_ERROR,
  DELETE_LINK_SUCCESS,

  SET_LINK_ENABLED,

  CLEAR_LINK,
  CLEAR_LINKS,

} from './constants';

export default {

  [GET_LINKS](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_LINKS_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
    state.links = [];
  },
  [GET_LINKS_SUCCESS](state, payload) {
    state.links = payload.map(link => ({
      ...link,
      enabled: false,
    }));
    state.loading = false;
  },

  [GET_LINK](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [GET_LINK_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [GET_LINK_SUCCESS](state, payload) {
    state.link = payload;
    state.success = true;
    state.loading = false;
  },

  [SAVE_LINK](state) {
    state.error = false;
    state.success = false;
    state.formLoading = true;
  },
  [SAVE_LINK_ERROR](state, payload) {
    state.error = payload;
    state.success = false;
    state.formLoading = false;
  },
  [SAVE_LINK_SUCCESS](state, payload) {
    state.link = payload;
    state.success = true;
    state.formLoading = false;
  },

  [DELETE_LINK](state) {
    state.success = false;
    state.error = false;
    state.loading = true;
  },
  [DELETE_LINK_ERROR](state, payload) {
    state.error = payload;
    state.loading = false;
  },
  [DELETE_LINK_SUCCESS](state) {
    state.success = true;
    state.link = false;
    state.loading = false;
  },
  [SET_LINK_ENABLED](state, { index, enabled }) {
    state.links[index].enabled = enabled;
  },
  [CLEAR_LINK](state) {
    state.link = {
      title: '',
      title_fr: '',
      link: '',
    };
  },
  [CLEAR_LINKS](state) {
    state.links = [];
  },

  // single object item mutation
  updateItem(state, payload) {
    state.links[payload.item] = payload.value;
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Links/mutations.js